document.addEventListener("DOMContentLoaded", function () {
  try {
    function hideSelectors() {
      const frame = document.querySelector(
        ".shopify-buy-frame--productSet iframe"
      );
      if (frame) {
        const $frame = $(frame.contentDocument);
        $frame.find(".shopify-buy__product__variant-selectors").hide();
        $frame.find(".shopify-buy__product__title").height(34);
      }
    }
    window.addEventListener("load", function () {
      hideSelectors();
      setTimeout(() => {
        hideSelectors();
      }, 1000);
    });
  } catch (e) {
    console.error(e);
  }

  var catalogue = document.querySelectorAll(".catalogue_li");

  for (var i = 0; i < catalogue.length; i++) {
    catalogue[i].setAttribute("data-target", ".title-" + [i + 1]);
  }

  $(".catalogue_li").click(function () {
    var target = $(this).data("target");
    console.log(target);
    var position = $(target).offset().top - 50;
    $("html, body").animate(
      {
        scrollTop: position,
      },
      1000
    );
  });

  var catalogue = document.querySelectorAll(".catalogue_2_li");

  for (var i = 0; i < catalogue.length; i++) {
    catalogue[i].setAttribute("data-target", ".small_directory_" + [i + 1]);
  }

  $(".catalogue_2_li").click(function (event) {
    var target = $(this).data("target");
    var position = $(target).offset().top;
    $("html, body").animate(
      {
        scrollTop: position,
      },
      1000
    );
    event.stopPropagation();
  });

  function initScrollTop() {
    var backToTop = $("#back-top");

    var p = 0,
      t = 0;
    $(window).scroll(function () {
      p = $(this).scrollTop();
      if (p > 220) {
        backToTop.fadeIn(400);
      } else {
        backToTop.fadeOut(400);
      }
      if (p == 0) {
        $("#back-top").removeClass("hide");
      }
      if (t < p) {
        //down
        $("#back-top").addClass("hide");
      } else {
        //up
        $("#back-top").removeClass("hide");
      }
      setTimeout(function () {
        t = p;
      }, 5000);
    });

    backToTop.off("click.scrollTop").on("click.scrollTop", function (e) {
      e.preventDefault();
      e.stopPropagation();

      $("html, body").animate(
        {
          scrollTop: 0,
        },
        400
      );
      return false;
    });
  }
  initScrollTop();
});
